import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../lib/api";
import { useAuth } from "../lib/AuthContext";

/* Processes the #session_id=... fragment after Emergent-managed Google OAuth.
   Exchanges it for a JOH. session and drops the user on the dashboard. */
export default function AuthCallback() {
  const location = useLocation();
  const nav = useNavigate();
  const { applyGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(location.hash.replace(/^#/, "")).get("session_id");
    if (!sessionId) {
      nav("/login", { replace: true });
      return;
    }
    (async () => {
      try {
        const { data } = await api.post("/auth/google/session", { session_id: sessionId });
        await applyGoogleSession(data.token, data.user);
        window.history.replaceState(null, "", window.location.pathname);
        // Google levert naam/e-mail automatisch; ontbrekende profielvelden eerst aanvullen (spec 2)
        const me = await api.get("/auth/me").then(r => r.data).catch(() => null);
        if (me && me.profile_complete === false) {
          nav("/profiel?next=/dashboard", { replace: true });
          return;
        }
        // Admins/owners gaan naar het admin-dashboard, members naar hun portaal
        if (["admin", "owner"].includes((me || data.user)?.role)) {
          nav("/admin", { replace: true });
          return;
        }
        nav("/dashboard", { replace: true, state: { user: data.user } });
      } catch (err) {
        toast.error("Google-login mislukt. Probeer het opnieuw.");
        nav("/login", { replace: true });
      }
    })();
  }, [location.hash, nav, applyGoogleSession]);

  return (
    <main className="min-h-screen bg-[#0A0A0A] text-[#F5F3F0] grain grain-dark flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <div className="font-logo text-3xl mb-4">JOH<span className="text-[#4A4A4A]">.</span></div>
        <div className="chip text-[#A3A3A3]" data-testid="auth-callback-status">Even geduld — we loggen je in…</div>
      </div>
    </main>
  );
}
